import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import {
  stockPortfolioListUrl,
  stockPortfolioDetailUrl,
  stockPortfolioBonusUrl,
  stockOrderOpenUrl,
  stockOrderHistoryUrl,
  stockAutoOrderListUrl,
} from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

// Portfolio
export const getStockPortfolio = () => fetchGet(stockPortfolioListUrl);

/**
 * @param {{ ticker_code: string }} payload
 */
export const getStockPortfolioDetail = (payload = {}) =>
  fetchGet(stockPortfolioDetailUrl, { query: payload });

export const getStockPortfolioBonus = () => fetchGet(stockPortfolioBonusUrl);


// Order history list
export const getStockOrderOpen = (query = {}) => fetchGet(stockOrderOpenUrl, { query });
export const getStockOrderHistory = (query = {}) => fetchGet(stockOrderHistoryUrl, { query });
export const getStockAutoOrderList = (query = {}) =>
  fetchGet(stockAutoOrderListUrl, { query: { ...query, account_type: 'REG' } });